<div class="container">
  <div class="content">
    <h1>OOPS!</h1>
    <p>Login failed with error: {{ message || 'N/A' }}. Please contact your administrator!</p>
  </div>
</div>